export default __webpack_public_path__ + "static/media/110t.e685f3ff.jpg";